import { type JSX, useEffect } from 'react';

import useThemeStore from '@/features/theme/stores/theme-store';
import {
  ClientTheme,
  Theme,
  type ThemeLayoutProps,
} from '@/features/theme/types/theme';

const ThemeLayout = ({ children }: ThemeLayoutProps): JSX.Element => {
  const { theme, clientTheme } = useThemeStore();

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove(theme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT);
    root.classList.add(theme);
  }, [theme]);

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove(...Object.values(ClientTheme));
    if (clientTheme) root.classList.add(clientTheme);
  }, [clientTheme]);

  return (
    <div className="h-screen dark:bg-black dark:text-white">{children}</div>
  );
};

export default ThemeLayout;
